export default {
  questionnaireList(state) {
    return state.questionnaireList
  },
  pager(state) {
    return state.pager
  },
  questionnaireReturnData(state) {
    return state.questionnaireData
  },
  rules(state) {
    return state.rules
  },
  columnSetting(state){
    return state.columnSetting
  }
}
